// Random fault rolls for troubleshooting missions, replayable on the server.
// The roll uses the lab's seeded generator (rt.random), so src/core/labVerify.js rebuilds exactly
// the same faults from the saved seed. A forced roll (admin fault picker, tests:
// window.__NELL_FAULTS__) is recorded in the lab state and accepted by the server only when the
// unit's validForced() says it is a roll the mission could have produced.

/** The forced roll for this attempt (server replay first, then the admin/test override), recorded on the lab. */
export function forcedRoll(rt) {
  const forced = rt.replayForced || (typeof window !== 'undefined' && window.__NELL_FAULTS__) || null;
  if (forced) rt.state.forced = forced;
  return forced;
}
/** One fault from each group, in group order. */
export const rollGroups = (FAULTS, groups, random) => groups.map((g) => {
  const ks = Object.keys(FAULTS).filter((k) => FAULTS[k].group === g);
  return ks[Math.floor(random() * ks.length)];
});
/** Validator for rollGroups results. */
export const groupRollValidator = (FAULTS, groups) => (f) => Array.isArray(f) && f.length === groups.length
  && f.every((k, i) => typeof k === 'string' && Object.hasOwn(FAULTS, k) && FAULTS[k].group === groups[i]);
/** Validator for "any n known faults". */
export const anyRollValidator = (FAULTS, n = 1) => (f) => Array.isArray(f) && f.length === n && f.every((k) => typeof k === 'string' && Object.hasOwn(FAULTS, k));
